import { LocationState } from "stores/wizard/state/global/location";
import { TravelersState } from "stores/wizard/state/global/travelers";
import { DateState } from "stores/wizard/state/global/date";
import { TypeaheadSelection } from "uitk-react-typeahead";
import { Travelers, TravelersMetadata } from "src/components/shared/TravelersField/typings";

// TODO: don't store loc tokens in state, only strings?
// TODO: do we still need config after we have constructed state? can we discard after constructor has run?

export abstract class LOBState {
  public config: any;
  public location: LocationState;
  public date: DateState;
  public travelers?: TravelersState;
  public hotelTravelersMetadata?: TravelersMetadata;
  public nonHotelTravelersMetadata?: TravelersMetadata;
  public subLOBState: string;

  public originInvalidKey?: string | "";
  public destinationInvalidKey?: string | "";
  public dateStartInvalidKey: string;
  public dateEndInvalidKey?: string;
  public hotelTravelersInvalidKey?: string;
  public nonHotelTravelersInvalidKey?: string;

  public setLastSearchCookie?: () => void;
  public updateOriginFromCookie?: (
    value: string,
    regionID: string,
    countryCode: string,
    latLong: string,
    ttla: string
  ) => void;
  public updateDestinationFromCookie?: (
    value: string,
    regionID: string,
    countryCode: string,
    latLong: string,
    ttla: string
  ) => void;
  public updateStateFromCookie?: () => void;

  public abstract overrideConfig: (callback: () => void) => void;
  public abstract updateSubLOBState: (subLOBState: string) => void;
  public abstract updateDateSelection: (start: Date, end: Date) => void;
  public abstract updateOriginSelection?: (selection: TypeaheadSelection, index?: number) => void;
  public abstract updateDestinationSelection: (
    selection: TypeaheadSelection,
    index?: number
  ) => void;
  public abstract swapLocations?: () => void;
  public abstract updateHotelTravelersSelection?: (travelers: Travelers) => void;
  public abstract updateNonHotelTravelersSelection?: (travelers: Travelers) => void;
  public abstract validateStartDateField?: () => boolean;
  public abstract validateEndDateField?: () => boolean;
  public abstract validateMaxDateRange?: () => boolean;
  public abstract validateLessThanNTravelers?: () => boolean;
  public abstract validateUnattendedInfantInLap?: () => boolean;
  public abstract validateForm: () => boolean;
  public abstract resetValidations: () => void;
  public abstract submit: (event: React.FormEvent) => void;
}
